import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
const endpoint = '/api/informe-tecnico-final';

export const getProyectosInformeTecnicoFinal = async () => {
  try {
    const response = await axios.get(`${baseUrl}${endpoint}/proyectos`);
    return { status: response.status, data: response.data || [] };
  } catch (error) {
    console.error('Error al obtener proyectos (Informe Técnico Final):', error);
    return { status: 500, data: [] };
  }
};

export const actualizarEstadoFinalizacion = async (oidProyecto, estado) => {
  const response = await axios.put(`${baseUrl}${endpoint}/${oidProyecto}/estado-finalizacion`, { estado });
  return { status: response.status, data: response.data };
};

export const descargarCarpetaInformeFinal = async (oidProyecto) => {
  const response = await axios.get(`${baseUrl}${endpoint}/${oidProyecto}/descargar`, {
    responseType: 'blob',
  });
  return response.data;
};
